import React from 'react'
import PropTypes from 'prop-types'
import ReactTooltip from 'react-tooltip'
import clsx from 'clsx'
import useScreen from '../../../hooks/useScreen'
import { v4 as uuidv4 } from 'uuid'

const CellLocation = ({
    label,
    address,
    isInCard,
    variant,
    otherClass = '',
}) => {
    const id = uuidv4()
    const { isMobile } = useScreen()

    const isInCardVal = isInCard && isMobile
    // const compressedAddress = address?.length > 30 ? address?.slice(0, 34) + '...' : address;

    const isBlack = variant === 'black' ? true : false
    return (
        <div
            className={clsx(
                'flex flex-col w-full max-w-full',
                otherClass,
                isInCardVal
                    ? 'lg:items-start items-start'
                    : 'lg:justify-end justify-start lg:items-start items-end',
            )}
        >
            <span
                className={clsx(
                    'text-base font-normal truncate max-w-full nobrea',
                    isBlack ? 'text-white' : 'text-black70',
                )}
            >
                {label}
            </span>
            <p
                data-tip
                className={clsx(
                    'text-sm font-normal text-textDarkGray md:truncate md:max-w-full',
                    isInCardVal
                        ? 'lg:text-left text-left lg:w-auto w-full lg:max-w-46.5 max-w-full truncate'
                        : 'lg:text-left text-right max-w-80 whitespace-normal',
                )}
            >
                {address}
            </p>
            <ReactTooltip id={id} place="top" effect="solid">
                {address}
            </ReactTooltip>
        </div>
    )
}

CellLocation.propTypes = {
    label: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
        PropTypes.element,
    ]),
    address: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
        PropTypes.element,
    ]),
    isInCard: PropTypes.bool,
    variant: PropTypes.string,
    otherClass: PropTypes.string,
}

export default CellLocation
